import styled from 'styled-components';

export const Links = styled.div`
    margin-top: 20px;

    & a {
        cursor: pointer;
        display: block;
        color: "[theme:link, default:#03787c]";
        color: var(--link); // note: CSS Custom Properties support is limited to modern browsers only

        &:hover {
        font-weight: bold;
        color: "[theme:linkHovered, default: #014446]";
        color: var(--linkHovered); // note: CSS Custom Properties support is limited to modern browsers only
        }
    }
`

export default Links;